// @ts-nocheck
import { Sparkle } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import { Text, XStack, YStack } from 'tamagui';

import { useIsMobile } from '../../hooks/useIsMobile';
import { useMotion } from '../../hooks/useMotion';

export function AISection() {
  const isMobile = useIsMobile();
  const { sectionReveal } = useMotion();

  return (
    <YStack
      paddingVertical={isMobile ? 60 : 80}
      paddingHorizontal="$5"
      maxWidth={1100}
      alignSelf="center"
      width="100%"
    >
      <motion.div
        {...sectionReveal}
        viewport={{ once: true, margin: '-100px' }}
      >
        <XStack
          gap="$5"
          padding={isMobile ? '$5' : '$7'}
          borderRadius="$3"
          backgroundColor="$color2"
          borderWidth={1}
          borderColor="$borderColor"
          alignItems="flex-start"
          flexDirection={isMobile ? 'column' : 'row'}
        >
          <Sparkle size={28} color="var(--accentBackground)" style={{ flexShrink: 0, marginTop: 4 }} />
          <YStack gap="$2" flex={1}>
            <Text
              fontSize={isMobile ? 20 : 24}
              fontWeight="700"
              letterSpacing={-0.5}
              lineHeight={isMobile ? 26 : 32}
              color="$color12"
            >
              AI-Ready Data Platform
            </Text>
            <Text
              fontSize={16}
              color="$color8"
              lineHeight={26}
              maxWidth={560}
            >
              Your unified data layer becomes the foundation for AI.
              Secure retrieval, structured queries, and future agent-driven automations — all built on the data you already have in Torch.
            </Text>
          </YStack>
        </XStack>
      </motion.div>
    </YStack>
  );
}
